const toggle = (name, time = 100) => state => {
  state[name] = true
  setTimeout(() => {
    state[name] = false
  }, time)
}

export default {
  namespaced: true,
  state: () => ({
    refreshError: false,
    notFoundError: false,
    requestError: false,
    serverError: false
  }),
  mutations: {
    refreshError: toggle('refreshError'),
    notFoundError: toggle('notFoundError'),
    requestError: toggle('requestError'),
    serverError: toggle('serverError')
  }
}
